<template>
  <!--表格和树型结构-->
  <div id="custom_table" class="main-tab">
    <el-table
      :class="isFirefox? 'isFirefox' : '' "
      :data="tableData"
      border
      stripe
      v-watermark:name="imagePath"
      style="width:100%"
      height="100%"
      highlight-current-row>
      <div v-for="(column,index) in tableColumns">
        <el-table-column
          v-if="!column.type"
          :fixed="column.fixed"
          :formatter="format"
          :width="column.width"
          :height="height"
          :render-header="renderHeader"
          header-align="center"
          :align="column.sortable ? 'right' : 'center'"
          :prop="column.name"
          :key="index"
          :index="index"
          :class="{'ascending': isAscending, 'descending': isDescending}"
          :label="column.title">
          <template slot-scope="scope">
            <router-link style="text-decoration:underline" :to="path + '?makerCode=' + scope.row.makerCode + '&brandCode=' + scope.row.brandCode + '&subBrandCode=' + scope.row.subBrandCode + '&countryCode=' + scope.row.countryCode + '&currentStartDay=' + timesObj.currentStartDay + '&currentEndDay=' + timesObj.currentEndDay + '&beforeStartDay=' + timesObj.beforeStartDay + '&beforeEndDay=' + timesObj.beforeEndDay" v-if="scope.column.property === 'county' && scope.row.countryCode !== '-' ">{{scope.row[column.name]}}</router-link>
            <span v-else>{{scope.row[column.name]}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="column.title"
          :prop="column.name"
          :fixed="column.fixed"
          :width="column.width"
          :height="height"
          :render-header="renderHeader"
          header-align="center"
          :align="column.sortable ? 'right' : 'center'"
          v-else-if="column.type === 'link'">
          <template
            slot-scope="scope">
            <span class="link-dialog"
              v-for="(link, idx) in column.links"
              :key="idx"
              size="mini"
              @click.prevent.stop="handleLink(idx, scope.row, link)">{{link.name}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="column.title"
          :prop="column.name"
          :fixed="column.fixed"
          :width="column.width"
          :height="height"
          :render-header="renderHeader"
          header-align="center"
          :align="column.sortable ? 'right' : 'center'"
          v-else-if="column.type === 'button'">
          <template
            slot-scope="scope">
            <el-button
              v-for="(button, idx) in column.buttons"
              v-if="buttonShow(scope.$index, scope.row, button)"
              :key="idx"
              size="mini"
              :disabled="!!button.disabled"
              @click.native.prevent.stop="handleButton(idx, scope.row, button)">{{button.name}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
        v-else-if="column.type === 'index'"
          :label="column.title"
          :fixed="column.fixed"
          :type="column.type"
          :formatter="format"
          :height="height"
          :render-header="renderHeader"
          header-align="center"
          :align="column.sortable ? 'right' : 'center'"
          :prop="column.name"
          :key="index"
          :index="index+1"
          :class="{'ascending': isAscending, 'descending': isDescending}"
          >
        </el-table-column>
      </div>
    </el-table>
    <!--弹窗-->
    <tabel-dialog
       ref="dlg"
      :dialog-visible="showDialog"
      @cancel="cancel">
      </tabel-dialog>
       <check-dialog
       ref="dlgc"
      :dialog-visible="dialogFalg"
      @cancel="cancel">
      </check-dialog>
  </div>
</template>
<script>
import { methodPost, methodGet } from '../../../api/request.js';
import tabelDialog from './tabel-dialog.vue';
import checkDialog from './check-dialog.vue';
import watermark from '@/directive/watermark/index.js'
let config = null
try {
  config = require('@/_app/' + process.env.PROJECT + '/src/config/index').default
  console.log(config)
} catch (e) {
  console.warn('config')
}
import columnSetting from '@/views/report/components/base/columnSetting.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'customTable',
  components: {
    columnSetting, tabelDialog, checkDialog
  },
  directives: {
    watermark
  },
  props: {
    columnName: {
      type: Object
    },
    organizeSeach: {
      type: Object
    },
    userSeach: {
      type: Object
    },
    type: {
      type: String,
      defalut: ''
    },
    pagetype: {
      type: String,
      defalut: ''
    },
    tableData: {
      type: Array
    },
    buttons: {
      type: Array,
      defalut: []
    },
    path: {
      type: String
    }
  },
  data() {
    return {
      isFirefox: false,
      showDialog: false,
      dialogFalg: false,
      tableColumns: this.columnName.columns,
      height: '0px',
      isAscending: false,
      isDescending: false,
      timesObj: {},
      selectedItem: {},
      selectId: [],
      width: 0

    }
  },
  created() {
    var userAgent = navigator.userAgent
    var isFirefox = userAgent.indexOf('Firefox') > -1
    var isCamino = userAgent.indexOf('Chrome') > -1
    if (isFirefox || isCamino) {
      this.isFirefox = true;
    }
    this.$eventBus.$on('onresize', (height) => {
      this.height = (document.body.clientHeight - (height + 165)) + 'px'
    })
    this.$eventBus.$on('hide-dialog', () => {
      this.reset()
    })
    this.$eventBus.$on('refresh-custom-table', () => {
      this.$emit('refresh')
    })

    this.$eventBus.$on('refresh-table-from-dialog', () => {
      this.$emit('refresh')
    })
  },
  computed: {
    ...mapGetters([
      'imagePath'
    ]),
    showColumnSetting() {
      return config && config.showColumnSetting
    },
    isBaseForm() {
      return this.meta.type === 'base-form'
    }
  },
  mounted() {
    this.width = document.getElementById('custom_table').clientWidth
    window.onresize = () => {
      return (() => {
        if (document.getElementById('custom_table')) {
          this.width = document.getElementById('custom_table').clientWidth
        }
      })()
    }
  },
  methods: {
    cancel() {
      this.dialogFalg = false;
      this.showDialog = false;
    },
    /* 排序 */
    sortChange(column, prop, order) {
      this.isAscending = true
      this.isDescending = false
      // console.log(column, prop, order)
    },
    /* 表头渲染 */
    renderHeader(h, { column, $index }) {
      if (column.label) {
        return (
          <span style={{ flexWrap: 'wrap', textAlgin: 'center' }}>
            <span className='custom_p' style={{ flex: 1, display: 'inline-block' }}>{column.label.split(',')[0]}</span>
            <span className='custom_p' style={{ flex: 1, display: 'inline-block' }}>{column.label.split(',')[1]}</span>
          </span>
        )
      } else {
        return (
          <span style={{ flexWrap: 'wrap', textAlgin: 'center' }}>
          </span>
        )
      }
    },
    /* 表中内容格式 */
    format(row, colunm, cellValue, index) {
      if (typeof (cellValue) === 'number') {
        return cellValue.toString().replace(/\d+/, function(n) { // 先提取整数部分
          return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) { // 对整数部分添加分隔符
            return $1 + ','
          })
        })
      } else {
        return cellValue
      }
    },
    buttonShow(index, row, button) {
      if (button.isShow) {
        const Fn = Function
        return new Fn('return ' + button.isShow)()(index, row, button)
      } else {
        return true
      }
    },
    handleButton(idx, obj, button) {
      let statusValue = obj.status;
      if (obj.status === "有效") {
        statusValue = '0'
      } else if (obj.status === "无效") {
        statusValue = '1'
      }
      if (button.event.type === 'router') {
        this.$router.push(button.event.path + '?method=update&id=' + obj.id)
      } else if (button.event.type === 'status-type') {
        if (this.pagetype === 'userManagement') {
          const params = {
            id: obj.id,
            status: statusValue,
            updated: obj.updated,
            updatedBy: obj.updatedBy
          }
          this.openTips(this.pagetype, '您确定要置为' + button.name, '确定提示', params)
        } else if (this.pagetype === 'organizationManagement') {
          this.openTips(this.pagetype, '您确定要' + button.name, '确定提示', obj)
        }
      } else if (button.event.type === 'delete') {
        methodGet("/sysOrganize/deleteOrganize/" + obj.id)
          .then(res => {
            if (res.code === 0) {
              this.$emit('query', {})
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(errData => {
            this.$message.error("error 出错了");
          });
      } else if (button.event.type === 'router') {
        if (this.pagetype === 'organizationManagement') {
          this.$router.push('/organizationManagement/add?id=' + obj.id)
        }
      } else if (button.event.type === 'type-role') {
        this.dialogFalg = true;
        let tableColumns = []
        tableColumns = [
          { name: 'roleCode', label: '系统角色代号' },
          { name: 'roleName', label: '系统角色名称' }
        ]
        // this.checkData(obj.id)
        this.openselectDialog(button.name, tableColumns, obj, '/role/simplelist')
      } else if (button.event.type === 'type-password') {
        this.openTips('password', '您确定要重置密码', '确定提示', obj.id)
      }
    },
    handleLink(idx, obj, link) {
      let tableColumns = []
      if (link.event.type === 'link-dialog') {
        this.showDialog = true;
        if (link.name === '角色详情') {
          tableColumns = [
            { name: 'roleCode', label: '系统角色代号' },
            { name: 'roleName', label: '系统角色名称' }
          ]
          this.openSAPDialog(link.name, tableColumns, obj, '/user/getRoleById/' + obj.id)
        } else if (link.name === '组织详情') {
          tableColumns = [
            { name: 'organizeCode', label: '所属组织代号' },
            { name: 'organizeName', label: '所属组织名称' },
            { name: 'upOrganizeCode', label: '上级组织代号' },
            { name: 'upOrganizeName', label: '上级组织名称' }
          ]
          this.openSAPDialog(link.name, tableColumns, obj, '/user/getOrganizeById/' + obj.id)
        }
      }
    },
    openSAPDialog(dlgTitle, tableColumns, obj, url) {
      this.$refs.dlg.open({
        dlgTitle: dlgTitle,
        url: url,
        tableColumns: tableColumns
      }).then(item => {
        // this.dataList = obj;
        this.showTabelFlag = false;
      })
    },
    openselectDialog(dlgTitle, tableColumns, obj, url) {
      this.$refs.dlgc.open({
        dlgTitle: dlgTitle,
        url: url,
        emptyMessage: '请选择分配角色',
        tableColumns: tableColumns,
        selectedItem: this.selectedItem,
        selectId: obj.id,
        idField: 'id'
      }).then(item => {
        this.dialogFalg = false;
      })
    },
    // 回显选择按钮
    checkData(id) {
      methodGet('/user/getRoleById/' + id).then(res => {
        if (res.code === 0) {
          this.selectId = res.data.map(o => o.id)
        }
      })
    },
    passwordEvent(id) {
      methodPost("/user/resetPassword", {
        userId: id
      }).then(res => {
        if (res.code === 0) {
          this.$message.success(`重置密码成功,密码为123456`)
          const data = {
            status: this.userSeach.status,
            account: this.userSeach.account,
            roleCode: this.userSeach.roleCode,
            userName: this.userSeach.userName
          }
          this.$emit('query', data)
        } else {
          this.$message.error(res.message);
        }
      }).catch(errData => {
        this.$message.error("error 出错了");
      });
    },
    openTips(type, text, tips, obj) {
      this.$confirm(text + '?', tips, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      }).then(() => {
        if (type === 'password') {
          this.passwordEvent(obj)
        } else if (type === 'userManagement') {
          this.exchangeUserEvent(obj)
        } else if (type === 'organizationManagement') {
          this.updateUserEvent(obj)
        }
      })
    },
    exchangeUserEvent(params) {
      methodPost("/user/exchangeUserStatus", params).then(res => {
        if (res.code === 0) {
          const data = {
            status: this.userSeach.status,
            account: this.userSeach.account,
            roleCode: this.userSeach.roleCode,
            userName: this.userSeach.userName
          }
          this.$emit('query', data)
        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        console.log(res)
      })
    },
    updateUserEvent(obj) {
      methodGet("/sysOrganize/updateStatusById/" + obj.id)
        .then(res => {
          if (res.code === 0) {
            const data = {
              status: this.organizeSeach.status,
              organizeName: this.organizeSeach.organizeName,
              organizeCode: this.organizeSeach.organizeCode,
              staffName: this.organizeSeach.staffName,
              upOrganizeName: this.organizeSeach.upOrganizeName
            }
            this.$emit('query', data)
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(errData => {
          this.$message.error("error 出错了");
        });
    }

  }
}
</script>
<style type="text/scss" lang="scss" scoped>
  .main-tab {
    flex: 1;
    display: flex;
    .el-table{
      height: none !important;
      height: auto !important;
    }
  }
  #popper {
    .title {
      font-weight: 700;
      color: #606266;
      font-size: 14px;
    }
    .content {
      padding: 5px;
      :first-child {
        color: #222;
        // font-weight: 600;
        font-size: 12px;
      }
      :last-child {
        color: #606266;
        font-size: 12px;
      }
    }
  }
  div {
    flex:1;
    .el-table {
      flex: 1;
      overflow: auto;
      .cell {
        white-space: nowrap;
      }
    }
  }
  .ascending {
    color: #00a0e9
  }
  .descending {
    color: #00a0e9
  }
  .info-icon{
    color: #00a0e9;font-size: 20px; position:absolute; top:-13px;left:10px;z-index:99;
    span{
      font-size: 14px;
      color: #111111;
    }
  }
  .link-dialog{
    display:inline-block;
    color:#4097d9;
    text-decoration:underline;
    cursor:pointer;
  }
</style>
<style>
  .custom_p {
    margin: 0;
    display: inline-block
  }
  .cell {
    position: relative !important;
  }
  .caret-wrapper {
    position:absolute !important;
    top: 0 !important;
  }
  .sort-caret.descending {
    bottom: 12px !important;
  }
  .sort-caret.ascending {
    top: 0px !important;
  }
  #app .userMainTable .main-tab,#app .userMainTable .page-warp{
    margin:0 !important;
  }
  #app .el-table__header-wrapper tr th{
    background-color:#f6faff !important;
    border-right: 1px solid #ebeef5;
    display: table-cell !important;
  }
  #app .el-table__fixed .el-table__body .el-table__row td{
    background: #fafafa !important;
  }
  #app .el-table__fixed-header-wrapper .el-table__header tr th{
    border-right:1px solid #ebeef5 !important;
  }
  .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell{
    color: rgba(49, 65, 86, 0.82)!important;
  }
  .el-table__header-wrapper tr th .cell{
    color: rgba(49, 65, 86, 0.82)!important;
  }
  .el-table--medium td, .el-table--medium th{
    padding:0;
  }
  #app .el-table .el-table__body-wrapper table tbody tr.el-table__row td .cell .el-button:hover {
    background-color: #4097d9 !important;
    border-color: #4097d9 !important;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/userManagementList/customTable/index.vue